// Önizleme hücre görüntüleri (M16 T11) — ImportPreviewStep'ten ayrıldı (dosya ≤600 satır).
// Türetilmiş hücre: değer / XXX / HESAPLANAMADI (amber token, --color-warning KULLANILMAZ).

import { formatKpiNumber, type KpiResolvedCell } from "@mahir/shared";
import { KPI_IMPORT_COPY } from "../../../lib/kpi-import-copy";
import { pillStyle } from "../kpi-form-styles";

function cellText(
  c: KpiResolvedCell | undefined,
  unit: string | null,
): { text: string; tone: "value" | "pending" | "error" | "empty" } {
  const p = KPI_IMPORT_COPY.preview;
  if (!c || c.status === "empty") return { text: p.dash, tone: "empty" };
  if (c.status === "calc_error")
    return c.hasPending
      ? { text: p.pendingXxx, tone: "pending" }
      : { text: p.calcError, tone: "error" };
  if (c.status === "pending_xxx") return { text: p.pendingXxx, tone: "pending" };
  if (typeof c.value === "number")
    return { text: formatKpiNumber(c.value, { percent: unit === "%" }), tone: "value" };
  return { text: c.text ?? p.dash, tone: "value" };
}

export function Cell({
  c,
  unit,
  strike,
}: {
  c: KpiResolvedCell | undefined;
  unit: string | null;
  strike?: boolean;
}): JSX.Element {
  const d = cellText(c, unit);
  if (d.tone === "error")
    return (
      <span
        style={{
          ...pillStyle,
          background: "var(--color-warning-bg)",
          color: "var(--color-warning-text)",
        }}
      >
        {d.text}
      </span>
    );
  return (
    <span
      style={{
        color:
          d.tone === "empty" || d.tone === "pending" ? "var(--color-text-3)" : "var(--color-text)",
        textDecoration: strike ? "line-through" : undefined,
      }}
    >
      {d.text}
    </span>
  );
}

export function existingText(
  e: { status: string; value: number | null; text: string | null } | undefined,
): string {
  const p = KPI_IMPORT_COPY.preview;
  if (!e || e.status === "empty") return p.dash;
  if (e.status === "pending_xxx") return p.pendingXxx;
  if (typeof e.value === "number") return formatKpiNumber(e.value);
  return e.text ?? p.dash;
}

export function incomingText(c: {
  status: string;
  numericValue?: number;
  textValue?: string;
}): string {
  const p = KPI_IMPORT_COPY.preview;
  if (c.status === "pending_xxx") return p.pendingXxx;
  if (c.status === "not_measured") return c.textValue ?? "Ölçülmüyor";
  if (c.numericValue !== undefined) return formatKpiNumber(c.numericValue);
  return c.textValue ?? p.dash;
}
